import React from 'react';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import RemindersFields from 'bundles/apex/reminders/reminders_fields';
import type { Deal } from 'bundles/apex/deals/types';
import type { Reminder } from 'bundles/apex/reminders/types';
import type { TaskFormState } from 'bundles/apex/tasks/types';
import { Button } from 'components/ui/button';

interface Props {
  dateNameWhitelist?: string[];
  deal?: Deal;
  fields?: any;
  reminders: Reminder[];
  task: TaskFormState;
  onChange: (reminders: Partial<Reminder>[]) => void;
}

export default function TaskRemindersFields({
  deal,
  fields,
  task,
  reminders = [],
  onChange,
  ...props
}: Props) {
  const handleAdd = () => {
    onChange([...reminders, { sendOn: undefined }]);
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <h6 className="fs-large fw-semibold">Reminders</h6>
        <Button icon={faCirclePlus} label="Add Reminder" variant="ghost" onClick={handleAdd} />
      </div>

      <RemindersFields
        dateNameWhitelist={['taskName']}
        deal={{ ...deal, taskName: task.deadline }}
        fields={{
          ...fields,
          taskName: { label: task.name || 'task', isDate: true },
        }}
        label=" "
        reminders={reminders}
        showAddControl={false}
        onChange={onChange}
        {...props}
      />
    </>
  );
}
